
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/roster/jst/resendInvitations';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <p>\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.pendingInvitationsCount), 1, options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.pendingInvitationsCount), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.available), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </p>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.resend_invitations")
  },data:data},helper ? helper.call(depth0, "courses.roster.resend_invitations.pending_invitation", "1 invitation hasn't been accepted.", options) : helperMissing.call(depth0, "t", "courses.roster.resend_invitations.pending_invitation", "1 invitation hasn't been accepted.", options)))
    + "\n    ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'pendingInvitationsCount': ((depth0 && depth0.pendingInvitationsCount)),
    'i18n_scope': ("courses.roster.resend_invitations")
  },data:data},helper ? helper.call(depth0, "courses.roster.resend_invitations.pending_invitations", "%{pendingInvitationsCount} invitations haven't been accepted.", options) : helperMissing.call(depth0, "t", "courses.roster.resend_invitations.pending_invitations", "%{pendingInvitationsCount} invitations haven't been accepted.", options)))
    + "\n    ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.sending), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <a href=\"javascript:void(0)\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.resend_invitations")
  },data:data},helper ? helper.call(depth0, "courses.roster.resend_invitations.re_sending_invitations", "Resending...", options) : helperMissing.call(depth0, "t", "courses.roster.resend_invitations.re_sending_invitations", "Resending...", options)))
    + "\n        </a>\n      ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <a href=\"javascript:void(0)\" class=\"resend-pending-invitations\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.resend_invitations")
  },data:data},helper ? helper.call(depth0, "courses.roster.resend_invitations.re_send_invitations", "Resend", options) : helperMissing.call(depth0, "t", "courses.roster.resend_invitations.re_send_invitations", "Resend", options)))
    + "\n        </a>\n      ";
  return buffer;
  }

  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.canResend), (depth0 && depth0.pendingInvitationsCount), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.canResend), (depth0 && depth0.pendingInvitationsCount), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  